
import ParcelPlaceholder from "../Parcel/ParcelPlaceholder.vue";
import { formatDate, gettersInstance, propsInstance } from "@/lib/util";
import { Component, MixedVue, mixins } from "@/vue";
import { Parcel } from "@/lib/types/Parcel";
import { RawLocation } from "vue-router";

const Props = propsInstance<{
  parcel: Parcel;
}>({
  parcel: { type: Object, required: true },
});

const StoreGetters = gettersInstance(["crops", "rastersSelectable", "currentFarmId", "currentSeasonId", "selectedDate", "userHasAccessToFarm"]);

@Component({
  name: "SearchResult",
  components: { ParcelPlaceholder },
})
export default class SearchResult extends mixins(MixedVue, Props, StoreGetters) {
  static components: {
    ParcelPlaceholder: typeof ParcelPlaceholder;
  };

  showCheckBox = false;

  get parcelName() {
    return this.parcel.name;
  }

  get clickRoute(): RawLocation {
    // Mobile app only has support for the latest date, so cater to that here
    let name = "map-parcel-selected";
    const params = {
      ...this.$route.params,
      seasonId: this.currentSeasonId,
      farmId: this.currentFarmId,
      parcelId: this.parcel.id,
    };
    if (this.$route.params.date) {
      name = "map-observation-details";
      params["date"] = formatDate(this.selectedDate);
    }

    return {
      name,
      params,
      query: { ...this.$route.query },
    };
  }

  /**
   * Current parcel crops.
   */
  get parcelCrop() {
    return this.getParcelCropName(this.parcel);
  }

  parcelClick() {
    if (this.rastersSelectable) {
      this.$store.commit("setParcelSelected", {
        parcelId: this.parcel.id,
        selected: true,
      });
    } else {
      this.$router.push(this.clickRoute);
    }
  }

  onInput() {
    if (!this.rastersSelectable) {
      this.$store.commit("setRastersSelectable", true);
    }
    this.$store.commit("toggleParcelSelected", this.parcel.id);
  }
}
